export const duplicateUser = (list, phoneNumber, key) => {
  const result = list.find((user) => user[key].includes(phoneNumber));
  return result;
};
